import ListItem from "@/components/ListItem/ListItem";
import { toFormat } from "@/lib/dateHelpers";

export type DraftParticipantRow = {
  draftId: string;
  personId: string;
  pgaId: string;
  displayName: string;
  profilePhoto: string | null;
  position: string;
  titleId: string;
  startDate: string;
  endDate: string;
  continuationOf?: { startDate: string; endDate: string | null };
};

type DraftParticipantListProps = {
  participants: DraftParticipantRow[];
  onEdit(draftId: string): void;
  onRemove(draftId: string): void;
};

export default function DraftParticipantList({ participants, onEdit, onRemove }: DraftParticipantListProps) {
  return (
    <div className="max-h-[min(50vh,24rem)] space-y-1 overflow-y-auto" data-testid="committee-participant-draft-list">
      {participants.map((participant) => (
        <div key={participant.draftId} data-testid={`draft-participant-${participant.pgaId}`}>
          <ListItem
            compact
            useAvatar
            picture={participant.profilePhoto ?? undefined}
            iconName="person"
            headline={participant.displayName}
            supportingText={`PGA ${participant.pgaId} · ${participant.position}\n${toFormat(participant.startDate)} – ${participant.endDate ? toFormat(participant.endDate) : "--"}`}
            tagText={participant.continuationOf ? "Continuing" : undefined}
            tagType={participant.continuationOf ? "information" : undefined}
            tagTestId={participant.continuationOf ? `draft-participant-continuing-${participant.pgaId}` : undefined}
            useCheckbox
            checkboxChecked
            checkboxToggleOnRowClick={false}
            onCheckboxChange={(checked) => {
              if (!checked) onRemove(participant.draftId);
            }}
            checkboxName={`draft-${participant.draftId}`}
            secondaryTrailingAction={() => onEdit(participant.draftId)}
            secondaryTrailingActionAriaLabel={`Edit ${participant.displayName}`}
            secondaryTrailingActionTestId={`draft-participant-edit-${participant.pgaId}`}
          />
        </div>
      ))}
    </div>
  );
}
